import React from 'react'
import SanityImage from 'gatsby-plugin-sanity-image'
import PortableText from '../portableText'
import Video from '../Video/Video'
import { TabContentPanel, TabLabel } from './Tab.styles'

const TCCopy = ({ portableTextBlock }) => <PortableText blocks={portableTextBlock} />

export function Tab({ tab, onClick, active }) {
	const { label, tagline } = tab

	return (
		<TabLabel onClick={onClick} active={active}>
			{label && <h3>{tab.label}</h3>}
			{tagline && <PortableText blocks={tagline} />}
		</TabLabel>
	)
}

export function TabContent({ tab, active }) {
	const { illustration, video, text } = tab

	return (
		<TabContentPanel active={active}>
			{video && <Video video={video} needsWrapper />}
			{illustration ? (
				<>
					{illustration.image.asset ? (
						<SanityImage asset={illustration.image.asset} alt={illustration.image.alt} {...illustration} />
					) : null}
				</>
			) : null}
			{text && <TCCopy {...text} />}
		</TabContentPanel>
	)
}
